import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SimpleSearchComponent } from "@webapp/search/simple-search/components/simple-search/simple-search.component";

@NgModule({
  imports: [FormsModule, SimpleSearchComponent],
})
export class PermissionsModule {}
